import { LOGO_URL, CONTACT, SERVICES } from "@/data/site";
import { Instagram, Linkedin, Youtube, Facebook, ArrowUpRight } from "lucide-react";

const QUICK_LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Process", href: "#process" },
  { label: "Clients", href: "#clients" },
  { label: "FAQ", href: "#faq" },
  { label: "Contact", href: "#contact" },
];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative bg-brand-brown text-white border-t border-white/10">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24 py-20 md:py-24">
        {/* Huge word */}
        <div className="mb-16">
          <p className="font-display italic text-[16vw] md:text-[10vw] leading-[0.9] tracking-tighter text-white/95">
            DigiDoot<span className="text-brand-gold">.</span>
          </p>
        </div>

        <div className="grid md:grid-cols-12 gap-10 md:gap-8 border-t border-white/15 pt-12">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <span className="w-14 h-14 rounded-full bg-brand-cream flex items-center justify-center overflow-hidden ring-1 ring-brand-gold/40">
                <img src={LOGO_URL} alt="DigiDoot" className="w-full h-full object-contain" />
              </span>
              <div>
                <p className="font-display text-2xl text-white">DigiDoot</p>
                <p className="text-xs uppercase tracking-[0.24em] text-white/50">Est. 2022 · Bengaluru South</p>
              </div>
            </div>
            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              A creative digital marketing agency helping ambitious brands grow through story, strategy and measurable performance.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow text-brand-gold mb-6">Quick links</p>
            <ul className="space-y-3">
              {QUICK_LINKS.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-white/80 hover:text-brand-gold transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-3">
            <p className="eyebrow text-brand-gold mb-6">Services</p>
            <ul className="space-y-3 text-sm text-white/80">
              {SERVICES.slice(0, 7).map((s) => (
                <li key={s.title}>{s.title}</li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="eyebrow text-brand-gold mb-6">Contact</p>
            <ul className="space-y-3 text-sm text-white/80">
              <li><a href={`mailto:${CONTACT.email}`} className="hover:text-brand-gold">{CONTACT.email}</a></li>
              <li><a href={`tel:+${CONTACT.phoneRaw}`} className="hover:text-brand-gold">{CONTACT.phone}</a></li>
              <li>{CONTACT.address}</li>
            </ul>
            <div className="mt-6 flex gap-2">
              {[
                { Icon: Instagram, url: CONTACT.socials.instagram },
                { Icon: Linkedin, url: CONTACT.socials.linkedin },
                { Icon: Youtube, url: CONTACT.socials.youtube },
                { Icon: Facebook, url: CONTACT.socials.facebook },
              ].map(({ Icon, url }, i) => (
                <a
                  key={i}
                  href={url}
                  target="_blank"
                  rel="noreferrer"
                  className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:bg-brand-gold hover:text-brand-charcoal hover:border-brand-gold transition"
                >
                  <Icon size={14} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-xs text-white/50">
          <p>© {year} DigiDoot. All rights reserved.</p>
          <a href="#top" className="inline-flex items-center gap-2 hover:text-brand-gold group">
            Back to top
            <ArrowUpRight size={14} className="group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-transform" />
          </a>
        </div>
      </div>
    </footer>
  );
}
